import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Chip,
  Paper,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Divider,
} from "@mui/material";
import {
  AccessTime,
  FormatListNumbered,
  CalendarToday,
} from "@mui/icons-material";

const SplitsDisplay = ({ splitsData }) => {
  if (!splitsData || splitsData.length === 0) {
    return (
      <Paper elevation={2} sx={{ p: 3, textAlign: "center" }}>
        <Typography variant="h6" color="textSecondary">
          No splits data available
        </Typography>
      </Paper>
    );
  }

  // Format the date for display
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      timeZone: "Asia/Kolkata", // Indian Standard Time
    });
  };
  return (
    <Box sx={{ p: 2 }}>
      <Typography
        variant="h6"
        gutterBottom
        sx={{
          fontWeight: "bold",
          color: "primary.main",
          mb: 3,
        }}
      >
        Data Splits
      </Typography>

      <Grid container spacing={3}>
        {splitsData.map((split, index) => (
          <Grid item xs={12} md={6} lg={4} key={index}>
            <Card
              elevation={3}
              sx={{
                height: "100%",
                transition: "transform 0.2s, box-shadow 0.2s",
                "&:hover": {
                  transform: "translateY(-4px)",
                  boxShadow: 6,
                },
                background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
              }}
            >
              <CardContent sx={{ p: 3 }}>
                {/* Header with List Name */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <ListItemIcon sx={{ minWidth: 40 }}>
                    <FormatListNumbered color="primary" />
                  </ListItemIcon>
                  <Typography
                    variant="h5"
                    component="h2"
                    sx={{ fontWeight: "bold" }}
                  >
                    List {index + 1}
                  </Typography>
                </Box>

                <Divider sx={{ my: 2 }} />

                {/* Count Display */}
                <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                  <Chip
                    icon={<FormatListNumbered />}
                    label={`Count: ${split.count}`}
                    color="primary"
                    variant="outlined"
                    sx={{
                      fontWeight: "bold",
                      fontSize: "1rem",
                      px: 1,
                    }}
                  />
                </Box>

                {/* Start Time Display */}
                <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
                  <AccessTime color="action" sx={{ mt: 0.5 }} />
                  <Box>
                    <Typography
                      variant="body2"
                      color="textSecondary"
                      gutterBottom
                    >
                      Start Time:
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: "medium" }}>
                      {formatDate(split.startTime)}
                    </Typography>
                  </Box>
                </Box>

                {/* Additional Info Chip */}
                <Box sx={{ mt: 2, display: "flex", gap: 1, flexWrap: "wrap" }}>
                  <Chip
                    icon={<CalendarToday />}
                    label="Scheduled"
                    size="small"
                    color="success"
                    variant="filled"
                  />
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Summary Section */}
      <Paper
        elevation={1}
        sx={{
          mt: 4,
          p: 3,
          background: "linear-gradient(45deg, #e3f2fd 30%, #f3e5f5 90%)",
        }}
      >
        <Typography
          variant="h6"
          gutterBottom
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          <FormatListNumbered color="primary" />
          Summary
        </Typography>
        <Typography variant="body1">
          Total Lists: <strong>{splitsData.length}</strong> | Total Items:{" "}
          <strong>
            {splitsData.reduce((sum, split) => sum + split.count, 0)}
          </strong>
        </Typography>
      </Paper>
    </Box>
  );
};
export default SplitsDisplay;
